import { takeUntil } from 'rxjs/operators';
import { Directive, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { BaseResourceService } from './services/base-resource.service';
import { FuncaoService } from '../util/funcao.service';
import { AbstractControl } from '@angular/forms';
import { BaseResourceModel } from './base-resource.model';
import { Page } from '../util/page';

@Directive()
export class EddyAutoComplete<T extends BaseResourceModel> implements OnDestroy {

  public lista: Array<T>;
  public id: number | string;
  protected unsubscribe: Subject<void> = new Subject();
  public limite = 10;

  constructor(
    private campoForm: AbstractControl,
    private service: BaseResourceService<T>,
    private campoChave: string,
    private campoLabel: string[],
    private parametros: {},
    private filtros: {
      number?: string[];
      date?: string[];
      text?: string[];
    },
    funcaoOnSelect?: any,
    limite?: any,
    private conversorPersonalizado?: (entidade: T) => {},
    private filtrarPersonilizado?: (pagina: number, limite: number, filtros: {}, filtroStr: string) => Observable<Page> // deve retornar um Promise<Page>
  ) {
    if (funcaoOnSelect) {
      this.funcaoOnSelect = funcaoOnSelect;
    }
    if (limite) {
      this.limite = limite;
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public funcaoOnSelect = () => {
    // deverá ser sobrescrita nas classes filhas
  }

  public filtrar(event: any) {
    let filtro: string = String(event.query).trim();
    const parametrosCampo = {};
    if (filtro) {
      filtro = filtro.trim();
      if (new FuncaoService().isNumber(filtro.split('.').join('').split(',').join('.').split('-').join('').split('/').join('')) && !filtro.match(/^\d{2}\/\d{2}\/\d{2}$/) && !filtro.match(/^\d{2}\/\d{2}\/\d{4}$/)) { // caso a pesquisa seja de um número
        if (this.filtros.number) {
          let filtroNumber: number | string = filtro.split('.').join('').split(',').join('.').split('-').join('');
          if (filtro.startsWith('0') && +filtroNumber > 0) {
            filtroNumber = +filtro.split('.').join('').split(',').join('.').split('-').join('');
          }
          let filtroNumberOR: string[] = [];
          for (const f of this.filtros.number) {
            filtroNumberOR = filtroNumberOR.concat(f.concat('$like=%').concat(String(filtroNumber + '%')));
            filtroNumberOR = filtroNumberOR.concat(f.concat('$like=%').concat(String(String(filtroNumber).split('/').join('') + '%')));
          }
          parametrosCampo['OR'] = filtroNumberOR.join(',');
        }

        if (this.filtros.text && filtro.startsWith('0')) {
          let filtroSemAcentos = new FuncaoService().removerAcentos(filtro);
          if (new FuncaoService().isNumber(filtro.split('.').join('').split(',').join('.').split('-').join(''))) { // caso a pesquisa seja de um número
            filtroSemAcentos = filtro.split('.').join('').split(',').join('.').split('-').join('');
          }

          let filtroTextOR: string[] = [];
          for (const f of this.filtros.text) {
            filtroTextOR = filtroTextOR.concat(f.concat('$like=%').concat(filtroSemAcentos).concat('%'));
            filtroTextOR = filtroTextOR.concat(f.concat('$like=%').concat(filtroSemAcentos.split('/').join('')).concat('%'));
          }
          if (parametrosCampo['OR']) {
            parametrosCampo['OR'] += ',' + filtroTextOR.join(',');
          } else {
            parametrosCampo['OR'] = filtroTextOR.join(',');
          }
        } else if (this.filtros.text) {
          let filtroSemAcentos = new FuncaoService().removerAcentos(filtro).split(',').join('');
          // caso exista apenas um campo de filtro inclui como parametro normal, caso contrário inclui como `OR`

          let filtroTextOR: string[] = [];
          for (const f of this.filtros.text) {
            filtroTextOR = filtroTextOR.concat(f.concat('$like=%').concat(filtroSemAcentos).concat('%'));
          }
          if (parametrosCampo['OR']) {
            parametrosCampo['OR'] += ',' + filtroTextOR.join(',');
          } else {
            parametrosCampo['OR'] = filtroTextOR.join(',');
          }
        }
      } else if (filtro.match(/^\d{2}\/\d{2}\/\d{2}$/) || filtro.match(/^\d{2}\/\d{2}\/\d{4}$/)) { // caso a pesquisa seja de uma data
        if (filtro.match(/^\d{2}\/\d{2}\/\d{2}$/)) {
          const dtSplit = filtro.split('/')
          filtro = `${dtSplit[0]}/${dtSplit[1]}/20${dtSplit[2]}`
        }
        if (this.filtros.date) {
          // caso exista apenas um campo de filtro inclui como parametro normal, caso contrário inclui como `OR`
          if (this.filtros.date.length === 1) {
            parametrosCampo[this.filtros.date[0]] = filtro;
          } else {
            let filtroDateOR: string[] = [];
            for (const f of this.filtros.date) {
              filtroDateOR = filtroDateOR.concat(f.concat('=').concat(filtro));
            }
            parametrosCampo['OR'] = filtroDateOR.join(',');
          }
        }
      } else { // caso a pesquisa seja de um texto
        if (this.filtros.text) {
          let filtroSemAcentos = new FuncaoService().removerAcentos(filtro);
          // caso exista apenas um campo de filtro inclui como parametro normal, caso contrário inclui como `OR`
          if (this.filtros.text.length === 1) {
            parametrosCampo[this.filtros.text[0].concat('$like')] = '%'.concat(filtroSemAcentos).concat('%');
          } else {
            let filtroTextOR: string[] = [];
            for (const f of this.filtros.text) {
              filtroTextOR = filtroTextOR.concat(f.concat('$like=%').concat(filtroSemAcentos).concat('%'));
            }
            parametrosCampo['OR'] = filtroTextOR.join(',');
          }
        }
      }
    }

    this.filtrarService(1, this.limite, Object.assign({}, this.parametros, parametrosCampo), filtro)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(lista => { this.lista = lista.content; }
      );

  }

  public async atualizar(campoCodigo: boolean, model?: { ngModel: T, field: string }) {
    await new Promise(resolve => {
      if (campoCodigo) {
        const entidade: any = model ? model.ngModel[model.field] : this.campoForm.value;
        if (entidade) {
          this.id = entidade[this.campoChave];
          resolve(true);
        } else {
          this.id = null;
          resolve(true);
        }
      } else {
        if (this.id) {
          this.filtrarService(1, this.limite, Object.assign({}, this.parametros, { [this.campoChave]: this.id }), '')
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(dados => {
              if (model)
                model.ngModel[model.field] = dados.content[0];
              else
                this.campoForm.setValue(dados.content[0]);
              resolve(true);
            }
            );
        } else {
          resolve(true);
        }
      }
    });
    this.funcaoOnSelect();
  }

  public conversor = (entidade: T) => {
    let retorno = '';

    if (this.conversorPersonalizado)
      return this.conversorPersonalizado(entidade);

    for (const campo of this.campoLabel) {
      let valor: any;
      const campoSplit = campo.split('.');
      for (const coluna of campoSplit) {
        if (!valor) {
          valor = entidade[coluna];
        } else {
          valor = valor[coluna];
        }
      }
      if (valor)
        retorno = retorno.concat(valor).concat(' - ');
    }

    if (retorno.length > ' - '.length)
      return retorno.substring(0, retorno.length - ' - '.length);
    else
      return retorno;
  }

  public onDropDownClick(event: any) {
    event.query = '';
    this.campoForm.setValue(null);
    this.id = null;
  }

  private filtrarService(pagina: number, limite: number, filtros: {}, filtroStr: string): Observable<Page> {
    if (!this.filtrarPersonilizado)
      return this.service
        .filtrar(pagina, limite, filtros);
    else
      return this.filtrarPersonilizado(pagina, limite, filtros, filtroStr);
  }
}
